import { userStore } from '@store/user';
import { isAdmin, isManager, isSuperAdmin } from '@utils/utils';
import { NotFound } from '@views/notFound';
import { JSX, Show, createSignal, onMount } from 'solid-js';

export function canViewCreditAdminPages(): boolean {
  return isAdmin() || isSuperAdmin();
}

export function canViewOfficeCreditApplicationMetrics(): boolean {
  return canViewCreditAdminPages() || isManager();
}

export function CreditAdminOnly(props: { children: JSX.Element }) {
  const [ready, setReady] = createSignal(false);

  onMount(() => {
    void userStore.userPromise.then(
      () => setReady(true),
      () => setReady(true),
    );
  });

  return (
    <Show when={ready()} fallback="Loading...">
      <Show when={canViewCreditAdminPages()} fallback={<NotFound />}>
        {props.children}
      </Show>
    </Show>
  );
}
